import {
  INQUIRY_FOREIGN_UNIV,
  JOB_HUNTING_STATUS_UPDATE,
  NEW_GRADES_PROFILE_UPDATE,
  PROFILE_BASE,
  REGISTS_AC_EMAIL,
  REGISTS_FINISH,
  RULE_CONFIRM,
  STUDENT_CARD,
} from '../../../config/constants/routes';

type Args = {
  isAuthenticated: boolean;
  isStudentVerified: boolean;
  pathname: string;
  isPostRegisterEntryPromptOpened: boolean;
  isPostRegisterEntryPromptDeciding: boolean;
};

// 完全一致で除外する
const EXCLUDED_PATHS = [REGISTS_AC_EMAIL, REGISTS_FINISH, INQUIRY_FOREIGN_UNIV];

// 子ページを含めて除外するため前方一致で判定する
const EXCLUDED_PATH_PREFIXES = [
  PROFILE_BASE,
  RULE_CONFIRM,
  NEW_GRADES_PROFILE_UPDATE,
  JOB_HUNTING_STATUS_UPDATE,
  STUDENT_CARD,
];

/**
 * ポップアップを出してよい状況かを判定する。
 * エントリー促進ポップアップとは二重表示になるため、そちらを優先する。
 */
export const canRequestUniversityEmailVerifyPrompt = ({
  isAuthenticated,
  isStudentVerified,
  pathname,
  isPostRegisterEntryPromptOpened,
  isPostRegisterEntryPromptDeciding,
}: Args): boolean => {
  if (
    !isAuthenticated ||
    isStudentVerified ||
    isPostRegisterEntryPromptOpened ||
    isPostRegisterEntryPromptDeciding ||
    EXCLUDED_PATHS.includes(pathname)
  ) {
    return false;
  }
  return !EXCLUDED_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
};
